(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7616],{

/***/ 92451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CH": function() { return /* binding */ TableUtilContainer; },
/* harmony export */   "Sb": function() { return /* binding */ LeftPane; },
/* harmony export */   "f5": function() { return /* binding */ SettingsComponent; },
/* harmony export */   "ol": function() { return /* binding */ ModalCloseButton; },
/* harmony export */   "r6": function() { return /* binding */ ModalTitle; }
/* harmony export */ });
/* unused harmony exports CloseIconStyle, CloseIconWrap, MainSettingPage, SettingsMainPane */
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56003);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80366);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var _excluded = ["onClick", "style"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var TableUtilContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
  displayName: "SettingsUtilComponent__TableUtilContainer",
  componentId: "sc-4ouiog-0"
})({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '8px 16px'
});
var ModalTitle = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
  displayName: "SettingsUtilComponent__ModalTitle",
  componentId: "sc-4ouiog-1"
})(["font-family:Noto Sans JP;font-style:normal;font-weight:bold;font-size:18px;line-height:26px;"]);
var CloseIconStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
  displayName: "SettingsUtilComponent__CloseIconStyle",
  componentId: "sc-4ouiog-2"
})(["font-size:20px;"]);
var CloseIconWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].span.withConfig({
  displayName: "SettingsUtilComponent__CloseIconWrap",
  componentId: "sc-4ouiog-3"
})(["cursor:pointer;"]);
var ModalCloseButton = function ModalCloseButton(_ref) {
  var onClick = _ref.onClick,
      style = _ref.style,
      props = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CloseIconWrap, _objectSpread(_objectSpread({
    style: style
  }, props), {}, {
    onClick: onClick,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CloseIconStyle, {})
  }));
};
var MainSettingPage = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
  displayName: "SettingsUtilComponent__MainSettingPage",
  componentId: "sc-4ouiog-4"
})(["display:flex;flex-direction:row;flex:0 1 100vh;height:100vh;"]);
var LeftPane = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
  displayName: "SettingsUtilComponent__LeftPane",
  componentId: "sc-4ouiog-5"
})(["display:flex;flex-direction:column;flex:0 0 16vw;overflow-y:auto;min-height:0;background-color:#F9F9F9;"]);
var SettingsMainPane = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
  displayName: "SettingsUtilComponent__SettingsMainPane",
  componentId: "sc-4ouiog-6"
})(["display:flex;flex-direction:column;flex:1 1 auto;border-right:1px solid #E5E5E5;border-left:1px solid #E5E5E5;"]);
var SettingsComponent = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
  displayName: "SettingsUtilComponent__SettingsComponent",
  componentId: "sc-4ouiog-7"
})(["flex:1;min-height:0;overflow-y:auto;border-top:1px solid #E5E5E5;"]);

/***/ }),

/***/ 44385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80366);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_outside_click_handler__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39834);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56003);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var useModal = function useModal() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(),
      activeModal = _useState[0],
      setActiveModal = _useState[1];

  var CloseButton = function CloseButton(_ref) {
    var style = _ref.style,
        onClick = _ref.onClick;

    var onClose = function onClose(e) {
      setActiveModal(undefined);
      onClick && onClick(e);
    };

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      className: "close-modal",
      style: _objectSpread({
        cursor: 'pointer',
        fontSize: '20px'
      }, style),
      onClick: onClose
    });
  };

  var closeModal = function closeModal() {
    setActiveModal(undefined);
  };

  var Modal = function Modal(_ref2) {
    var id = _ref2.id,
        children = _ref2.children,
        styleOverlay = _ref2.styleOverlay,
        styleContentModal = _ref2.styleContentModal;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(ModalContainer, {
      id: id,
      style: styleOverlay,
      isOpen: activeModal === id,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_outside_click_handler__WEBPACK_IMPORTED_MODULE_2__["default"], {
        onOutsideClick: closeModal,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(PopUp, {
          style: styleContentModal,
          children: children
        })
      })
    });
  };

  return {
    closeModal: closeModal,
    openModal: function openModal(idModal) {
      setActiveModal(idModal);
    },
    Modal: Modal,
    ModalCloseButton: CloseButton,
    isActiveModal: function isActiveModal(idModal) {
      return activeModal === idModal;
    }
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useModal);
var ModalContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "useModal__ModalContainer",
  componentId: "sc-2grmiy-0"
})(["position:absolute;top:0;bottom:0;left:0;right:0;z-index:100000;background:rgba(0,0,0,0.5);transition:opacity 200ms;visibility:", ";opacity:", ";"], function (props) {
  return props.isOpen ? 'visible' : 'hidden';
}, function (props) {
  return props.isOpen ? '1' : '0';
});
var PopUp = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div.withConfig({
  displayName: "useModal__PopUp",
  componentId: "sc-2grmiy-1"
})(["top:50%;left:50%;transform:translate(-50%,-50%);padding:20px;background:#fff;border:1px solid #666;width:400px;max-width:90%;max-height:90vh;overflow-y:auto;position:absolute;"]);

/***/ }),

/***/ 92071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ signup; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./src/components/auth/AuthLayout.tsx + 1 modules
var AuthLayout = __webpack_require__(4151);
// EXTERNAL MODULE: ./src/components/chat/ChatPane/UtilButton.tsx
var UtilButton = __webpack_require__(26761);
// EXTERNAL MODULE: ./src/components/utils/Auth.tsx
var Auth = __webpack_require__(25147);
// EXTERNAL MODULE: ./src/components/utils/LoggedInUserProvider.tsx
var LoggedInUserProvider = __webpack_require__(57159);
// EXTERNAL MODULE: ./src/components/utils/useDetectOldBrowser.tsx
var useDetectOldBrowser = __webpack_require__(66361);
// EXTERNAL MODULE: ./src/data/themes/index.ts + 7 modules
var themes = __webpack_require__(13725);
// EXTERNAL MODULE: ./src/utils/getEnv.ts
var getEnv = __webpack_require__(55940);
// EXTERNAL MODULE: ./src/utils/formatter.ts
var formatter = __webpack_require__(57791);
// EXTERNAL MODULE: ./src/utils/hooks/useFondasiFetch.ts
var useFondasiFetch = __webpack_require__(17012);
;// CONCATENATED MODULE: ./src/utils/hooks/v3/auth/useSignup.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function useSignup() {
  var _useApi = (0,useFondasiFetch/* useApi */.h_)(),
      data = _useApi.data,
      error = _useApi.error,
      isValidating = _useApi.isValidating,
      call3 = _useApi.call3;

  return {
    signedUpData: data,
    signingUp: isValidating,
    errorSignUp: error,
    signUp: function signUp(payload, invitation) {
      return call3({
        url: '/auth/register',
        method: 'post',
        data: {
          invitation: invitation,
          globalUser: _objectSpread(_objectSpread({}, payload), {}, {
            password: (0,formatter/* encryptPassword */.vC)(payload.password)
          })
        }
      });
    }
  };
}
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(1925);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js
var TextField = __webpack_require__(39803);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(30553);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(80797);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormHelperText/FormHelperText.js
var FormHelperText = __webpack_require__(30585);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Alert/Alert.js + 5 modules
var Alert = __webpack_require__(15046);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 8 modules
var styled_components_browser_esm = __webpack_require__(56003);
// EXTERNAL MODULE: ./src/components/settings/SettingsUtilComponent.tsx
var SettingsUtilComponent = __webpack_require__(92451);
// EXTERNAL MODULE: ./src/components/utils/useModal.tsx
var useModal = __webpack_require__(44385);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/signup/useTermsAndConditionsModal.tsx
var _themes, _themes$muiTheme, _themes$muiTheme$pale, _themes$muiTheme$pale2;











var useTermsAndConditionsModal = function useTermsAndConditionsModal() {
  var _useModal = (0,useModal/* default */.Z)(),
      Modal = _useModal.Modal,
      ModalCloseButton = _useModal.ModalCloseButton,
      openModal = _useModal.openModal,
      closeModal = _useModal.closeModal;

  var TermsAndConditionsModal = function TermsAndConditionsModal(_ref) {
    var setIsAccept = _ref.setIsAccept;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal, {
        id: "termsAndConditions",
        styleContentModal: {
          width: 'max-content'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ModalCloseButton, {
          style: {
            "float": 'right'
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SettingsUtilComponent/* ModalTitle */.r6, {
          children: "Terms and Conditions"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Content, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Subtitle2, {
            children: "PQ ini merupakan satu kesatuan dari Form CMD. Kecuali ditentukan lain dalam PQ ini , definisi-definisi dalam PQ ini akan memiliki arti yang sama sebagaimana ditetapkan dalam Ketentuan Berlangganan pada Form CMD."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Subtitle2, {
            style: {
              color: '#7B7B7B'
            },
            children: "This PQ is an integral part of the CMD form. Unless otherwise stated in this PQ, the definitions in this PQ will have the same meaning as stated in the Subscription Terms to the CMD Form."
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledOl, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Body1, {
                children: "Harga yang tertera di atas adalah dalam satuan Rupiah."
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Body1, {
                style: {
                  color: '#7B7B7B'
                },
                children: "Price stated above is in IDR (Rp - Rupiah)."
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Body1, {
                children: "Kecuali diatur lain pada PQ dan lampiran, Pelanggan dengan ini setuju untuk membayar denda (penalty) sebagaimana disebutkan pada Ketentuan Berlangganan. "
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Body1, {
                style: {
                  color: '#7B7B7B'
                },
                children: "Unless otherwise stated in PQ and its attachment, Customer hereby agrees to pay a penalty as stated in the Subscription Terms."
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Body1, {
                children: "Penghitungan tagihan akan dimulai setelah layanan aktif berdasarkan tanggal aktivasi pertama kali atau Berita Acara  yang telah ditandatangani oleh para pihak (mana yang relevan). "
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Body1, {
                style: {
                  color: '#7B7B7B'
                },
                children: "Charging will be started once the service is activated based on the first activation date or based on the signed  certificate (berita acara), whichever is relevant."
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Body1, {
                children: "Berita acara akan diterbitkan setelah layanan aktif. Pelanggan dianggap menyetujui berita acara  tersebut jika selama 5 hari kerja sejak tanggal penerbitan berita acara dimaksud, tidak ada respon/tanggapan atau alasan penolakan yang wajar dari Pelanggan dan MMB (Minimum Monthly Billing) akan diberlakukan."
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Body1, {
                style: {
                  color: '#7B7B7B'
                },
                children: "Certificate (berita acara) will be issued after the service has been activated. Customer is deemed had been agreed to the certificate (berita acara)if within 5 working days since such the issuance date of certificate, there is no response/feedback or reasonable reason for rejection from Customer and MMB (Minimum Monthly Billing) will be applied."
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Body1, {
                children: "Kecuali diatur lain pada PQ dan lampiran, Pelanggan dengan ini setuju untuk membayar denda (penalty) sebagaimana disebutkan pada Ketentuan Berlangganan. "
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Body1, {
                style: {
                  color: '#7B7B7B'
                },
                children: "Unless otherwise stated in PQ and its attachment, Customer hereby agrees to pay a penalty as stated in the Subscription Terms."
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(UtilButton/* default */.Z, {
          variant: "contained",
          color: "primary",
          type: "button",
          style: {
            "float": 'right'
          },
          onClick: function onClick() {
            setIsAccept(true);
            closeModal();
          },
          children: "ACCEPT"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            padding: 8,
            "float": 'right'
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(UtilButton/* default */.Z, {
          variant: "outlined",
          color: "primary",
          type: "button",
          style: {
            "float": 'right'
          },
          onClick: function onClick() {
            setIsAccept(false);
            closeModal();
          },
          children: "DECLINE"
        })]
      })
    });
  };

  return {
    openTermsAndCondtitionsModal: function openTermsAndCondtitionsModal() {
      openModal('termsAndConditions');
    },
    TermsAndConditionsModal: TermsAndConditionsModal
  };
};

/* harmony default export */ var signup_useTermsAndConditionsModal = (useTermsAndConditionsModal);
var Subtitle2 = styled_components_browser_esm["default"].div.withConfig({
  displayName: "useTermsAndConditionsModal__Subtitle2",
  componentId: "sc-13hczim-0"
})(["font-family:'Trueno',sans-serif;font-style:normal;font-weight:400;font-size:14px;line-height:21px;color:#000000;"]);
var Body1 = styled_components_browser_esm["default"].div.withConfig({
  displayName: "useTermsAndConditionsModal__Body1",
  componentId: "sc-13hczim-1"
})(["font-family:'Trueno';font-style:normal;font-weight:300;font-size:14px;line-height:20px;color:#000000;"]);
var StyledOl = styled_components_browser_esm["default"].ol.withConfig({
  displayName: "useTermsAndConditionsModal__StyledOl",
  componentId: "sc-13hczim-2"
})(["padding:0 18px 0 16px;font-family:'Trueno';font-style:normal;font-weight:300;font-size:14px;line-height:20px;color:#000000;li{padding-bottom:8px;}"]);
var Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "useTermsAndConditionsModal__Content",
  componentId: "sc-13hczim-3"
})(["max-width:770px;max-height:50vh;overflow-y:auto;margin-bottom:16px;::-webkit-scrollbar{width:8px;height:8px;}::-webkit-scrollbar-thumb{background:", ";border-radius:0;}"], ((_themes = themes/* default */.Z[getEnv/* CLIENT */.ID || '']) === null || _themes === void 0 ? void 0 : (_themes$muiTheme = _themes.muiTheme) === null || _themes$muiTheme === void 0 ? void 0 : (_themes$muiTheme$pale = _themes$muiTheme.palette) === null || _themes$muiTheme$pale === void 0 ? void 0 : (_themes$muiTheme$pale2 = _themes$muiTheme$pale.primary) === null || _themes$muiTheme$pale2 === void 0 ? void 0 : _themes$muiTheme$pale2.main) || '#D0D6DD');
;// CONCATENATED MODULE: ./src/pages/signup/index.tsx





function signup_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function signup_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? signup_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : signup_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






 // import { AuthClient } from '@/types/index'

















var SignupPage = function SignupPage() {
  var _themes$CLIENT, _themes$CLIENT$head;

  var _useForm = (0,index_esm/* useForm */.cI)(),
      control = _useForm.control,
      handleSubmit = _useForm.handleSubmit,
      setValue = _useForm.setValue;

  var _useDetectOldBrowser = (0,useDetectOldBrowser/* default */.Z)(),
      ErrorOldBrowser = _useDetectOldBrowser.ErrorOldBrowser;

  var _useSignup = useSignup(),
      signUp = _useSignup.signUp,
      signedUpData = _useSignup.signedUpData,
      signingUp = _useSignup.signingUp,
      errorSignUp = _useSignup.errorSignUp; // const [grantType, _] = useState<AuthClient>('password')


  var _useLoggedInUser = (0,LoggedInUserProvider/* useLoggedInUser */.q)(),
      _useLoggedInUser2 = (0,slicedToArray/* default */.Z)(_useLoggedInUser, 2),
      _loggedInUser = _useLoggedInUser2[0],
      setLoggedInUser = _useLoggedInUser2[1];

  var _useTermsAndCondition = signup_useTermsAndConditionsModal(),
      TermsAndConditionsModal = _useTermsAndCondition.TermsAndConditionsModal,
      openTermsAndCondtitionsModal = _useTermsAndCondition.openTermsAndCondtitionsModal;

  var _useState = (0,react.useState)(false),
      isAccepted = _useState[0],
      setIsAccepted = _useState[1];

  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    if (router.query.email) {
      setValue('email', router.query.email);
    }
  }, []);
  (0,react.useEffect)(function () {
    if (signedUpData) {
      setLoggedInUser(signup_objectSpread({}, signedUpData === null || signedUpData === void 0 ? void 0 : signedUpData.globalUser));
      (0,Auth/* saveLoginTokenToCookie */.SO)(signedUpData.jwt.token);
      var token = router.query.token;

      if (token) {
        router.replace({
          pathname: '/accept-invite',
          query: {
            token: token
          }
        });
      } else {
        router_default().push('/signup/success');
      }
    }
  }, [signedUpData]);

  var onSubmit = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data, event) {
      var invitation;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event === null || event === void 0 ? void 0 : event.preventDefault();
              invitation = undefined;

              if (router.query.token) {
                invitation = {
                  token: router.query.token
                };
              }

              _context.next = 5;
              return signUp(signup_objectSpread(signup_objectSpread({}, data), {}, {
                clientId: getEnv/* GRANT_PASSWORD_CLIENT_ID */.S6
              }), invitation);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("title", {
        children: ["Sign up | ", ((_themes$CLIENT = themes/* default */.Z[getEnv/* CLIENT */.ID]) === null || _themes$CLIENT === void 0 ? void 0 : (_themes$CLIENT$head = _themes$CLIENT.head) === null || _themes$CLIENT$head === void 0 ? void 0 : _themes$CLIENT$head.text) || 'Fondasi']
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          children: "Sign Up"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(AuthLayout/* StyledSubtitle */.TK, {
          children: "Enter your personal details to create an account"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ErrorAlert, {
        children: [ErrorOldBrowser, errorSignUp ? /*#__PURE__*/(0,jsx_runtime.jsx)(Alert/* default */.Z, {
          severity: "error",
          children: errorSignUp.error
        }) : null]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
        id: "signup",
        onSubmit: handleSubmit(onSubmit),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
          control: control,
          name: 'name',
          rules: {
            required: 'Full Name is required'
          },
          render: function render(_ref2) {
            var field = _ref2.field,
                error = _ref2.fieldState.error;
            return /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, {
              id: "signup-name",
              autoComplete: "name",
              variant: "outlined",
              margin: "dense",
              required: true,
              disabled: signingUp,
              label: "Full Name",
              type: "text",
              error: error !== undefined,
              helperText: error === null || error === void 0 ? void 0 : error.message,
              onChange: field.onChange,
              value: field.value || '',
              fullWidth: true
            });
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
          control: control,
          name: 'email',
          rules: {
            required: 'Email is required'
          },
          render: function render(_ref3) {
            var field = _ref3.field,
                error = _ref3.fieldState.error;
            return /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, {
              id: "signup-email",
              autoComplete: "email",
              variant: "outlined",
              margin: "dense",
              required: true,
              error: error !== undefined,
              helperText: error === null || error === void 0 ? void 0 : error.message,
              disabled: signingUp || !!router.query.email,
              label: "Email",
              type: "email",
              onChange: field.onChange,
              value: field.value || '',
              fullWidth: true
            });
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
          control: control,
          name: 'phoneNumber',
          rules: {
            required: 'Phone Number is required',
            pattern: {
              value: /\+[0-9]{9,14}/i,
              message: 'Phone number must be valid phone number, start with +'
            }
          },
          render: function render(_ref4) {
            var field = _ref4.field,
                error = _ref4.fieldState.error;
            return /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, {
              id: "signup-mobile",
              autoComplete: "mobile",
              variant: "outlined",
              margin: "dense",
              required: true,
              error: error !== undefined,
              helperText: "Input your phone with '+' sign and country code. i.e: +6288877766655",
              disabled: signingUp,
              label: "Your Phone Number",
              type: "tel",
              onChange: field.onChange,
              value: field.value || '',
              fullWidth: true
            });
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
          control: control,
          name: 'password',
          rules: {
            required: 'Password is required',
            validate: function validate(value) {
              return !(0,utils/* isValidPassword */.eW)(value) ? 'Your password must at least have 8 characters in length, 1 upper case letter, 1 lower case letter, 1 special character, 1 number' : undefined;
            }
          },
          render: function render(_ref5) {
            var field = _ref5.field,
                error = _ref5.fieldState.error;
            return /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, {
              id: "signup-new-password",
              autoComplete: "new-password",
              variant: "outlined",
              margin: "dense",
              required: true,
              disabled: false,
              label: "Password",
              type: "password",
              error: error !== undefined,
              helperText: error === null || error === void 0 ? void 0 : error.message,
              onChange: field.onChange,
              value: field.value || '',
              fullWidth: true
            });
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
          name: "termsAndConditions",
          control: control,
          rules: {
            required: "You must accept ".concat(getEnv/* CLIENT */.ID === 'smartfren' ? '1ENGAGE' : 'Fondasi', " Terms and Conditions to signup")
          },
          render: function render(_ref6) {
            var controlField = _ref6.field,
                error = _ref6.fieldState.error;
            return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                error: !!error,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                  control: /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, signup_objectSpread(signup_objectSpread({}, controlField), {}, {
                    onChange: function onChange(e) {
                      controlField.onChange(e.target.checked);
                      setIsAccepted(e.target.checked);
                      setValue('termsAndConditions', e.target.checked, {
                        shouldValidate: true
                      });
                      return e.target.checked;
                    },
                    checked: controlField.value || isAccepted,
                    color: "primary",
                    disabled: signingUp
                  })),
                  label: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: getEnv/* CLIENT */.ID === 'smartfren' ? /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                      children: ["I accept ", /*#__PURE__*/(0,jsx_runtime.jsx)("b", {
                        style: {
                          textDecoration: 'underline'
                        },
                        onClick: function onClick(e) {
                          e.preventDefault();
                          e.stopPropagation();
                          openTermsAndCondtitionsModal();
                        },
                        children: "1ENGAGE Terms and Conditions"
                      })]
                    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                      children: ["I accept Fondasi ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        href: "https://www.bahasa.ai/terms-of-services",
                        target: "_blank",
                        children: "Terms of service"
                      }), " and ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        href: "https://www.bahasa.ai/privacy-policy",
                        target: "_blank",
                        children: "Privacy policy"
                      })]
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledFormHelperText, {
                  style: {
                    padding: 16,
                    marginTop: -28
                  },
                  children: error === null || error === void 0 ? void 0 : error.message
                })]
              })
            });
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonSignUp, {
          control: control,
          signingUp: signingUp || false
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LoginLink, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Have an account? \xA0"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/login",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            color: "primary",
            children: "Login"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TermsAndConditionsModal, {
        setIsAccept: function setIsAccept(isAccept) {
          setValue('termsAndConditions', isAccept, {
            shouldDirty: true,
            shouldTouch: true,
            shouldValidate: true
          });
          setIsAccepted(isAccept);
        }
      })]
    })]
  });
};

/* harmony default export */ var signup = ((0,AuthLayout/* withAuthLayout */.l$)(SignupPage));
var Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "signup__Container",
  componentId: "sc-kxgx0j-0"
})(["display:flex;width:100%;flex-direction:column;justify-content:flex-start;align-items:flex-start;max-width:500px;@media (max-width:800px){padding:0;}"]);
var LoginLink = styled_components_browser_esm["default"].div.withConfig({
  displayName: "signup__LoginLink",
  componentId: "sc-kxgx0j-1"
})(["display:flex;flex-direction:row;align-items:center;margin-left:auto;margin-right:auto;font-family:'Trueno';font-style:normal;font-weight:300;font-size:14px;line-height:22px;color:#000000;margin-top:8px;.MuiTypography-root{font-size:inherit;cursor:pointer;font-weight:bold;}"]);
var ErrorAlert = styled_components_browser_esm["default"].div.withConfig({
  displayName: "signup__ErrorAlert",
  componentId: "sc-kxgx0j-2"
})(["align-self:center;justify-self:center;"]);
var StyledFormHelperText = (0,styled_components_browser_esm["default"])(FormHelperText/* default */.Z).withConfig({
  displayName: "signup__StyledFormHelperText",
  componentId: "sc-kxgx0j-3"
})(["color:#f44336;"]);

var ButtonSignUp = function ButtonSignUp(_ref7) {
  var signingUp = _ref7.signingUp,
      control = _ref7.control;
  var watchAll = (0,index_esm/* useWatch */.qo)({
    control: control
  });
  var keys = Object.keys(watchAll);
  var disabled = keys.reduce(function (res, name) {
    return res || !watchAll[name];
  }, false) // check smua fields ada isinya
  || keys.length < 5; // check smua fields dirty

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(UtilButton/* default */.Z, {
    disabled: signingUp || disabled,
    fullWidth: true,
    variant: "contained",
    color: "primary",
    type: "submit",
    children: [signingUp && /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
      size: 20,
      style: {
        color: '#FFF'
      }
    }), "\xA0", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      children: signingUp ? 'SIGNING UP..' : 'SIGN UP'
    })]
  });
};

/***/ }),

/***/ 57791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fj": function() { return /* binding */ currencyFormatterIDR; },
/* harmony export */   "Ft": function() { return /* binding */ formatWhatsapp; },
/* harmony export */   "c8": function() { return /* binding */ appendDynamicParamIfMissing; },
/* harmony export */   "vC": function() { return /* binding */ encryptPassword; }
/* harmony export */ });
/* unused harmony exports formatterValueBracket, camelToSnakeCase, snakeToCamelCase, getDataWithSnakeCase, getDataWithCamelCase, getDataWithAllSnakeCase, getDataWithAllCamelCase, formatTextToSlug */


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function formatterValueBracket(text) {
  if (text) {
    return text.replace(/\{{2,3}.*?\}{2,3}/gi, function (value) {
      var vals = value.replace(/[\{\}]/gi, '').trim().split('.');
      return '{{{' + vals.map(function (attr) {
        return "[".concat(attr, "]");
      }).join('.') + '}}}';
    });
  }

  return '';
}
function currencyFormatterIDR(num) {
  if (num) {
    return "IDR ".concat("".concat(num).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'));
  }

  return 'IDR 0';
}
function camelToSnakeCase(str) {
  return str.replace(/[A-Z]/g, function (letter) {
    return "_".concat(letter.toLowerCase());
  });
}
function snakeToCamelCase(str) {
  return str.replace(/(_\w)/g, function (k) {
    return k[1].toUpperCase();
  });
}

var isObject = function isObject(obj) {
  return obj && typeof obj === 'object' && typeof (obj === null || obj === void 0 ? void 0 : obj.getMonth) !== 'function' && !Array.isArray(obj) && typeof obj !== 'function';
};

function getDataWithSnakeCase(payload) {
  return Object.keys(payload).reduce(function (res, key) {
    return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, camelToSnakeCase(key), payload[key]));
  }, {});
}
function getDataWithCamelCase(payload) {
  return Object.keys(payload).reduce(function (res, key) {
    return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, snakeToCamelCase(key), payload[key]));
  }, {});
}
function getDataWithAllSnakeCase(payload) {
  if (isObject(payload)) {
    return Object.keys(payload).reduce(function (res, key) {
      return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, camelToSnakeCase(key), getDataWithSnakeCase(payload[key])));
    }, {});
  } else if (Array.isArray(payload)) {
    return payload.map(function (i) {
      return getDataWithSnakeCase(i);
    });
  }

  return payload;
}
function getDataWithAllCamelCase(payload) {
  if (isObject(payload)) {
    return Object.keys(payload).reduce(function (res, key) {
      return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, snakeToCamelCase(key), getDataWithCamelCase(payload[key])));
    }, {});
  } else if (Array.isArray(payload)) {
    return payload.map(function (i) {
      return getDataWithCamelCase(i);
    });
  }

  return payload;
}
function formatTextToSlug(text) {
  return text === null || text === void 0 ? void 0 : text.toLowerCase().replace(/ +|_/g, '-').replace(/[-]+/g, '-').replace(/[^\w-]+/g, '-');
}
function encryptPassword(password) {
  var result;

  if (false) {} else {
    // browser
    result = window.btoa(password);
  }

  return result;
}
function formatWhatsapp(text) {
  if (text) {
    var replaceItalic = text.replace(/(^|[^a-zA-Z0-9_])\_{1}(.+?)\_/g, function (_match, p1, p2) {
      return "".concat(p1, "<i>").concat(p2, "</i>");
    });
    var replaceBold = replaceItalic.replace(/(^|[^a-zA-Z0-9_])\*{1}(.+?)\*/g, function (_match, p1, p2) {
      return "".concat(p1, "<b>").concat(p2, "</b>");
    });
    var replaceStrike = replaceBold.replace(/(^|[^a-zA-Z0-9_])\~{1}(.+?)\~/g, function (_match, p1, p2) {
      return "".concat(p1, "<strike>").concat(p2, "</strike>");
    });
    var replaceMono = replaceStrike.replace(/(^|[^a-zA-Z0-9_])\`{3}(.+?)\`\`\`/g, function (_match, p1, p2) {
      return "".concat(p1, "<span class=\"font-mono\">").concat(p2, "</span>");
    });
    return replaceMono;
  }

  return '';
}
function appendDynamicParamIfMissing(url) {
  if (!url.includes('{{1}}')) {
    // Check if the URL ends with a slash, or includes ?
    if (url.endsWith('/') || url.includes('?')) {
      url += '{{1}}';
    } else {
      url += '/{{1}}';
    }
  }

  return url;
}

/***/ }),

/***/ 28575:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup",
      function () {
        return __webpack_require__(92071);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2003,9669,5046,5459,9803,1664,7536,9834,5518,9691,4151,8143,9774,2888,179], function() { return __webpack_exec__(28575); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);